import React from 'react';
import FreightInfo from './FreightInfo';
import Orders from './Orders';
import Notes from './Notes';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';
import useRules from "../../../../../../hooks/useRules"
import Alerts from "./Alerts"
import ListPhones from "./Phones/ListPhones"

const useStyles = makeStyles((theme) => ({
  divider: {
    margin: theme.spacing(1, 0),
  },
}));

function CustomerMainCard(props) {
  const classes = useStyles();
  const [rules,hasRule,isAdmin] = useRules();
  return (
    <>
      <Alerts />
      <FreightInfo />
      <Divider className={classes.divider} />
      <ListPhones />
      <Divider className={classes.divider} />
      <Notes />
      <Divider className={classes.divider} />
      <Orders />
    </>
  );
}

export default CustomerMainCard;
